import React from 'react';
import { Button } from 'primereact/button';

const DataDifferentFromCountAccountOrganisationSizeNotification = ({
  updateNotification,
  updateNotificationWithRedirect,
}) => {
  return (
    <div>
      <p>
        The number of Internal Respondents you have on file is larger than the size of your organisation. This typically
        happens when:
      </p>
      <ul>
        <li>
          Your organisation has grown and therefore you have more Internal Respondents. If that is the case, you should
          <strong
            style={{
              marginLeft: '0.25rem',
              marginRight: '0.25rem',
            }}
            className="underline pointer"
            onClick={updateNotificationWithRedirect}
          >
            update
          </strong>
          the size of your organisation now.
        </li>
        <br />
        <li>
          Your organisation has shrunk, but you forgot to delete the people who are no longer with you. If that is the
          case, you should delete them now and then
          <strong
            style={{
              marginLeft: '0.25rem',
              marginRight: '0.25rem',
            }}
            className="underline pointer"
            onClick={updateNotificationWithRedirect}
          >
            update
          </strong>
          the size of your organisation.
        </li>
        <br />
        <li>
          You have Internal Respondents on file who do not have a long-term relation with your organisation (e.g., as an
          employee). If that is the case, you must regularly obtain their (written) consent to keep and use their data.
          Alternatively, you should delete them now.
        </li>
      </ul>
      <p>
        If you have any doubts or questions, please do not hesitate to contact our Data Protection Officer at
        <a href="mailto:dpo@greatpeopleinside.com"> dpo@greatpeopleinside.com.</a>
      </p>
      <div className="center">
        <Button type="button" className="p-button-primary " label="GOT IT" onClick={updateNotification} />
      </div>
    </div>
  );
};

export default DataDifferentFromCountAccountOrganisationSizeNotification;
